export default {
    data() {
        return {
            valid: {
                gift_category: false,
                gift_type: false,
                title: false,
                description: false,
                points: false,
                cost: false,
                supplier: false,
                tier: !this.tierSwitch,
            },
            success: {
                gift_category: false,
                gift_type: false,
                title: false,
                description: false,
                points: false,
                cost: false,
                tier: !this.tierSwitch,
                supplier: false
            },
            error: {
                gift_category: "",
                gift_type: "",
                title: "",
                description: "",
                points: "",
                cost: "",
                tier: "",
                supplier: ""
            },
            errorMessages: {
                giftCategoryRequired: {
                    el: "Απαιτείται κατηγορία δώρου",
                    en: "Gift Category is required",
                    it: "La categoria regalo è obbligatoria"
                },
                giftTypeRequired: {
                    el: "",
                    en: "Gift Type is required",
                    it: ""
                },
                titleRequired: {
                    el: "",
                    en: "Title is required",
                    it: ""
                },
                descriptionRequired: {
                    el: "",
                    en: "Description is required",
                    it: ""
                },
                pointsRequired: {
                    el: "",
                    en: "Points is required",
                    it: ""
                },
                costRequired: {
                    el: "",
                    en: "Cost is required",
                    it: ""
                },
                supplierRequired: {
                    el: "",
                    en: "Supplier is required",
                    it: ""
                },
                tierRequired: {
                    el: "Επιλέξτε επίπεδο",
                    en: "Tier is required",
                    it: ""
                }
            }
        };
    },

    computed: {
        formValid() {
            return this.mode === 1
                ? 
                this.valid.gift_category && 
                this.valid.gift_type && 
                this.valid.title &&
                this.valid.description && 
                this.valid.points && 
                this.valid.cost
                : true;
        }
    },

    methods: {
        validateGiftCategory() {
            if (!this.gift.gift_category_id) {
                this.error.gift_category = this.errorMessages.giftCategoryRequired[
                    this.lang
                ];
            } else {
                this.error.gift_category = "";
            }
        },

        validateGiftType() {
            if (!this.gift.gift_type_id) {
                this.error.gift_type = this.errorMessages.giftTypeRequired[
                    this.lang
                ];
            } else {
                this.error.gift_type = "";
            }
        },

        validateTitle() {
            if (!this.gift.title) {
                this.error.title = this.errorMessages.titleRequired[
                    this.lang
                ];
            } else {
                this.error.title = "";
            }
        },

        validateDescription() {
            if (!this.gift.description) {
                this.error.description = this.errorMessages.descriptionRequired[
                    this.lang
                ];
            } else {
                this.error.description = "";
            }
        },

        validatePoints() {
            if (!this.gift.points) {
                this.error.points = this.errorMessages.pointsRequired[
                    this.lang
                ];
            } else {
                this.error.points = "";
            }
        },

        validateCost() {
            if (!this.gift.cost) {
                this.error.cost = this.errorMessages.costRequired[
                    this.lang
                ];
            } else {
                this.error.cost = "";
            }
        },

        validateSupplier() {
            if (!this.gift.supplier_store_id) {
                this.error.supplier = this.errorMessages.supplierRequired[
                    this.lang
                ];
            } else {
                this.error.supplier = "";
            }
        },

        validateTier() {
            if (this.tierSwitch&&!this.gift.store_point_title_id) {
                this.error.tier = this.errorMessages.tierRequired[
                    this.lang
                ];
            } else {
                this.error.tier = "";
                this.success.tier = !!this.gift.store_point_title_id
                this.valid.tier = parseInt(this.gift.store_point_title_id) > 0
            }
        }
    },

    watch: {
        ["gift.gift_category_id"]: {
            immediate: true,
            handler(val) {
                this.valid.gift_category = !!val;
                this.success.gift_category = !!val;
            }
        },

        ["gift.gift_type_id"]: {
            immediate: true,
            handler(val) {
                this.valid.gift_type = !!val;
                this.success.gift_type = !!val;
            }
        },

        ["gift.title"]: {
            immediate: true,
            handler(val) {
                this.valid.title = !!val;
                this.success.title = !!val;
            }
        },

        ["gift.description"]: {
            immediate: true,
            handler(val) {
                this.valid.description = !!val;
                this.success.description = !!val;
            }
        },

        ["gift.points"]: {
            immediate: true,
            handler(val) {
                this.valid.points = !!val;
                this.success.points = !!val;
            }
        },

        ["gift.cost"]: {
            immediate: true,
            handler(val) {
                this.valid.cost = !!val;
                this.success.cost = !!val;
            }
        },

        ["gift.supplier_store_id"]: {
            immediate: true,
            handler(val) {
                this.valid.supplier = !!val;
                this.success.supplier = !!val;
            }
        },

        ["gift.store_point_title_id"]: {
            immediate: true,
            handler(val) {
                this.valid.tier = !this.tierSwitch || this.tierSwitch&&!!val;
                this.success.tier = true ||!this.tierSwitch ||  this.tierSwitch&&!!val;
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    gift_category: false,
                    gift_type: false,
                    title: false,
                    description: false,
                    points: false,
                    cost: false,
                    tier: false,
                    success: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        gift_category: "",
                        gift_type: "",
                        title: "",
                        description: "",
                        points: "",
                        cost: "",
                        tier: "",
                        success: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
